export const cancelPacketsEnrollmentDefault = '{\n' +
    '    "contractId": ""\n' +
    '    "programName": ""\n' +
    '    "version": ""\n' +
    '}';

export interface ICancelPacketsEnrollmentRequest {
    contractId: string
    programName: string
    version: string
}
